import React, { useCallback, useEffect } from "react";
import { Card } from "antd";
import Title from "antd/es/typography/Title";
import SmoothLineChart from "./components/SmoothLineChart";
import { bookingperMonth } from "../ducks/service";
import LoaderTsx from "../../../Loader.tsx";

import { useQuery } from "@tanstack/react-query";
import { useDashboardFilterContext } from "../../hooks/DashboardFilterProvider";

const BookingsPerMonth: React.FC = React.memo(() => {
  const filterData = useDashboardFilterContext();
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["bookingperMonth", filterData?.queryParams],
    queryFn: () => bookingperMonth(filterData?.queryParams),
    staleTime: 1000 * 60 * 5, // ✅ 5 minutes
    refetchOnWindowFocus: false, // 👈 disable auto refetch when window regains focus
  });
  
  return (
    <Card
      style={{
        backgroundColor: "#FFFFFF",
        borderRadius: 20,
        border: "1px solid #E9E9E9",
        boxShadow: "none",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Title
          level={5}
          style={{
            margin: 0,
            color: "#1F5782",
            textTransform: "uppercase",
            fontWeight: 400,
          }}
        >
          <span style={{ fontWeight: 700 }}>BOOKINGS</span> <span style={{ fontWeight: 400 }}>PER MONTH</span>
        </Title>
      </div>

      {isLoading ? <LoaderTsx height={"30vh"} /> : <SmoothLineChart data={data?.result} />}
    </Card>
  );
});

export default BookingsPerMonth;
